export const COLORS = {
  Red: "#E20015",
  Fuchsia: "#B90276",
  Fuchsia50: "#DC80BA",
  Violet: "#50237F",
  Violet50: "#A791BF",
  DarkBlue: "#005691",
  DarkBlue50: "#7FAAC8",
  LightBlue: "#008ECF",
  LightBlue50: "#7FC6E7",
  Turquoise: "#00A8B0",
  Turquoise50: "#7fd3d7",
  LightGreen: "#78BE20",
  LightGreen50: "#bbde8f",
  DarkGreen: "#006249",
  DarkGreen50: "#7fb0a4",
  Green: "#328D46",
  White: "#FFFFFF",
  LightGray: "#BFC0C2",
  DarkGray: "#525F6B",
  Black: "#000000",
  SignalGreen: "#70BF54",
  SignalYellow: "#FCAF17",
  SignalRed: "#E11F26",
  SignalOrange: "#FF6A00",

  /* Shades */
  RedW75: "#F8BFC5",
  RedW50: "#F17F8B",
  RedW25: "#EA4051",
  RedB25: "#A90010",
  RedB50: "#71000B",
  RedB75: "#390005",
  FuchsiaW75: "#EDC0DD",
  FuchsiaW50: "#DC80BA",
  FuchsiaW25: "#CB4198",
  FuchsiaB25: "#8B0158",
  FuchsiaB50: "#5D013B",
  FuchsiaB75: "#2E011E",
  VioletW75: "#D3C8DF",
  VioletW50: "#A791BF",
  VioletW25: "#7C5A9F",
  VioletB25: "#3C1A5F",
  VioletB50: "#281240",
  VioletB75: "#140920",
  DarkBlueW75: "#BFD5E3",
  DarkBlueW50: "#7FAAC8",
  DarkBlueW25: "#4080AD",
  DarkBlueB25: "#00406D",
  DarkBlueB50: "#002B49",
  DarkBlueB75: "#001624",
  LightBlueW75: "#BFE3F3",
  LightBlueW50: "#7FC6E7",
  LightBlueW25: "#40AADB",
  LightBlueB25: "#006A9B",
  LightBlueB50: "#004768",
  LightBlueB75: "#002434",
  TurquoiseW75: "#BFE9EB",
  TurquoiseW50: "#7FD3D7",
  TurquoiseW25: "#40BEC4",
  TurquoiseB25: "#007E84",
  TurquoiseB50: "#005458",
  TurquoiseB75: "#002A2C",
  LightGreenW75: "#DDEFC7",
  LightGreenW50: "#BBDE8F",
  LightGreenW25: "#9ACE58",
  LightGreenB25: "#5A8E18",
  LightGreenB50: "#3C5F10",
  LightGreenB75: "#1E3008",
  DarkGreenW75: "#BFD8D1",
  DarkGreenW50: "#7FB0A4",
  DarkGreenW25: "#408977",
  DarkGreenB25: "#004937",
  DarkGreenB50: "#003125",
  DarkGreenB75: "#001912",
  LightGrayW75: "#EFEFF0",
  LightGrayW50: "#DFDFE0",
  LightGrayW25: "#CFD0D1",
  LightGrayB25: "#8F9091",
  LightGrayB50: "#606061",
  LightGrayB75: "#303031",
  DarkGrayW75: "#D4D7DA",
  DarkGrayW50: "#A8AFB5",
  DarkGrayW25: "#7D8790",
  DarkGrayB25: "#3D4750",
  DarkGrayB50: "#293036",
  DarkGrayB75: "#15181B"
};
